// this will cause errors when importing it - that's fine - that's the point opf this mock
// eslint-disable-next-line
wat()
